module.exports = "//static.hsappstatic.net/pricing-pages-lib/static-1.25482/images/keyFeatures/Form_Shortening.png"